import * as Yup from "yup";

export type exportValueTypes = {
  exportFormat: string;
  usageStatus: string;
  cardStatus: string;
};

export const initalValues: exportValueTypes = {
  exportFormat: "CSV",
  usageStatus: "All",
  cardStatus: "Active",
};

export const exportValidationSchema = Yup.object({
  exportFormat: Yup.string().required("Facility is Required"),
  usageStatus: Yup.string().required("Status is Required"),
  cardStatus: Yup.string().required("Card Status is Required"),
});
